export enum LocalStorageKey {
  ACCESS_TOKEN = 'accessTokenCognito',
  HOLDING_ID = 'holding',
  POS_ID = 'pos',
  EXPIRED_PASSWORD_EMAIL = 'expiredPasswordEmail',
  TOKEN_EXPIRATION_DATE = 'tokenExpirationDateCognito',
}

export function getItem(key: LocalStorageKey) {
  return localStorage.getItem(key);
}

export function setItem(key: LocalStorageKey, value: string): void {
  localStorage.setItem(key, value);
}

export function removeItem(key: LocalStorageKey) {
  localStorage.removeItem(key);
}
